import UtilsFncs from "utils/UtilsFncs.js";
import getEndpoints from "../apiEndpoints.js";
import storageFnc from "../localStorage.js";
import { removeUserFirebaseId } from "components/Notification/Notifications.js";

const apiKey = "4loZGJ5Nw76xEvh7bpN8941ji26JpbqN6sfPtag1";

async function refreshToken() {
  await requestToken()
    .then(async (token) => {
      if (token?.ExpiresIn) {
        const dtNow = new Date();
        const dtFuture = new Date(dtNow.getTime() + token.ExpiresIn * 1000);
        const newTokenToSave = {
          accessToken: token?.AccessToken,
          dtExpiration: dtFuture,
        };
        localStorage.setItem("ApiCredentials", JSON.stringify(newTokenToSave));
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

function verifyIsSessionInactive() {
  let result = false;

  const lastRequest = localStorage.getItem("dateLastRequest");

  if (lastRequest) {
    const dtlastreq = new Date(JSON.parse(lastRequest));
    const dtNow = new Date();

    const diffHours = Math.ceil(Math.abs(dtNow - dtlastreq) / (1000 * 60 * 60));

    if (diffHours < 4)
      //4 horas de sessao
      localStorage.setItem("dateLastRequest", JSON.stringify(new Date()));
    else result = true;
  } else localStorage.setItem("dateLastRequest", JSON.stringify(new Date()));

  return result;
}

async function doLogout() {
  storageFnc.clear();
  UtilsFncs.RedirectToLoginPage();
}

async function getApiHeaders(usekId = true, customKId) {
  const h = new Headers();
  let userId = "";
  const kIdUser = localStorage.getItem("k-user");
  const kIdUserVision = localStorage.getItem("k-user-vision");
  const userVision = localStorage.getItem("userVision");
  const verifyUrl = window.location.href;

  if (kIdUserVision) {
    if (verifyUrl?.includes("troca-usuario") && userVision) {
      userId = kIdUser;
    } else {
      userId = kIdUserVision;
    }
  } else {
    if (verifyUrl.includes("vitrine-virtual-cliente?")) {
      userId = "7dfab031-1096-497c-8f5c-aa76704b71c1";
    } else {
      userId = kIdUser;
    }
  }

  if (verifyIsSessionInactive()) {
    doLogout();
    return h;
  }

  h.append("x-api-key", apiKey);
  h.append("Content-Type", "application/json");

  const user = customKId || userId;

  if (user && usekId) h.append("k-iduser", user);

  // { "accessToken": "dsafdasdasd", "dtExpiration": new Date() }
  let session = JSON.parse(localStorage.getItem("ApiCredentials"));
  let needsRefreshToken = false;

  if (session && session?.accessToken && session.dtExpiration) {
    const dtExp = new Date(session.dtExpiration);
    const dtNow = new Date();

    const diffSeconds = Math.ceil(Math.abs(dtNow - dtExp) / 1000);

    if (diffSeconds < 60) needsRefreshToken = true;
  } else needsRefreshToken = true;

  if (needsRefreshToken) {
    await refreshToken().then(async () => {
      session = JSON.parse(localStorage.getItem("ApiCredentials"));
    });
  }

  h.append("Authorization", "Bearer " + session.accessToken);

  return h;
}

async function requestPost(method, endpoint, path, body, usekId) {
  const apiEndpoints = getEndpoints();
  const url = `${apiEndpoints[endpoint]}${path}`;

  const options = {
    method,
    headers: await getApiHeaders(usekId),
    dataType: "json",
    body: JSON.stringify(body),
    data: JSON.stringify(body),
  };

  return request(url, options);
}

async function requestPostParams(method, endpoint, path, parameter, usekId) {
  const apiEndpoints = getEndpoints();
  const url = `${apiEndpoints[endpoint]}${path}${parameter}`;

  const options = {
    method,
    headers: await getApiHeaders(usekId),
    dataType: "json",
  };

  return request(url, options);
}

async function requestGet(
  method,
  endpoint,
  path,
  parameter,
  usekId,
  customKId
) {
  const apiEndpoints = getEndpoints();
  const url = `${apiEndpoints[endpoint]}${path}${parameter}`;

  const options = {
    method,
    headers: await getApiHeaders(usekId, customKId),
    dataType: "json",
  };
  return request(url, options);
}

const updateUserNotificationId = async (idFirebase) => {
  return removeUserFirebaseId(idFirebase);
};

async function request(url, options) {
  return await fetch(url, options).then(async (response) => {
    const data = await response.json();

    if (!response.ok) {
      const error =
        data?.message ||
        data?.Message ||
        data?.ErrorMessage ||
        data?.errorMessage ||
        response.status;

      if (options.headers && response.status === 401) {
        const userFirebaseId = localStorage.getItem("userFirebaseId");

        if (userFirebaseId) {
          updateUserNotificationId(userFirebaseId);

          localStorage.removeItem("userFirebaseId");
        }

        storageFnc.clear();
        localStorage.setItem("sessionExpired", "true");
        if (window.location.href.includes("karsten-portal-b2b-test")) {
          window.location.href = process.env.PUBLIC_URL + "/index.html?auth/login";
        } else {
          window.location.href = "/auth/login";
        }
      } else if (data?.message?.includes("timed out")) {
        return Promise.reject(
          "A requisição com os parâmetros utilizados levou tempo demais para responder. Simplifique sua requisição e tente novamente."
        );
      } else
        return Promise.reject(error?.replace(/^(HTTPERRO\s[0-9]*\s)/g, ""));
    } else if (
      data?.errorMessage?.includes(
        "Response payload size exceeded maximum allowed payload size"
      )
    ) {
      return Promise.reject(
        "A requisição com os parâmetros utilizados encontrou muitos resultados. Simplifique sua requisição e tente novamente."
      );
    }

    return data;
  });
}

async function getTokenHeaders() {
  const headers = new Headers();

  headers.append("x-api-key", apiKey);
  headers.append("Authorization", "Basic MDA4MjEyNDAwMDU6c2VuaGFhbGVhdG9yaWE=");

  return headers;
}

async function requestToken() {
  const apiEndpoints = getEndpoints();
  const url = `${apiEndpoints["token"]}token`;

  const options = { method: "POST", headers: await getTokenHeaders() };
  let result;

  await fetch(url, options)
    .then(async (response) => {
      const data = await response.json();
      if (!response.ok) {
        const error = (data && data.message) || response.status;
        return Promise.reject(error);
      }

      result = {
        AccessToken: data?.Result?.AccessToken,
        ExpiresIn: data?.Result?.ExpiresIn,
      };
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });

  return result;
}

const Api = {
  get(path, endpoint, parameter, usekId, customKId) {
    return requestGet("GET", endpoint, path, parameter, usekId, customKId);
  },
  post(path, endpoint, data = {}, usekId) {
    return requestPost("POST", endpoint, path, data, usekId);
  },
  put(path, endpoint, data = {}, usekId) {
    return requestPost("PUT", endpoint, path, data, usekId);
  },
  delete(path, endpoint, data = {}, usekId) {
    return requestPost("DELETE", endpoint, path, data, usekId);
  },
  getToken() {
    return requestToken();
  },
  postParams(path, endpoint, parameter, usekId) {
    return requestPostParams("POST", endpoint, path, parameter, usekId);
  },
  deleteParams(path, endpoint, parameter, usekId) {
    return requestPostParams("DELETE", endpoint, path, parameter, usekId);
  },
  refreshToken() {
    return refreshToken();
  },
};

export default Api;
